module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_01-35b8a85d2ecf516c76156a7bd2b95546.png";